import { useState } from "react";
import { Link } from "react-router-dom";
import { Download, Share2, RotateCcw, ChevronDown } from "lucide-react";
import { fileUrl, downloadVideo, shareTikTok } from "@/hooks/useVideo";

export const VideoResult = ({ video, onNew, trial, onUnlock }) => {
  const [showScript, setShowScript] = useState(false);
  const [sharing, setSharing] = useState(false);
  const share = async () => {
    setSharing(true);
    await shareTikTok(video);
    setSharing(false);
  };
  return (
    <div className="w-full" data-testid="video-result">
      <div className="mx-auto w-full max-w-[300px] overflow-hidden rounded-[2rem] bg-[#111111] p-2 shadow-[0_30px_80px_-30px_rgba(0,102,255,0.55)]">
        <video src={fileUrl(video.video_url)} controls playsInline autoPlay className="aspect-[9/16] w-full rounded-[1.6rem] bg-black object-cover" data-testid="video-player" />
      </div>
      <p className="font-display mt-6 text-center text-xl font-bold" data-testid="video-title">{video.titolo}</p>
      <p className="mt-1 text-center text-sm text-[#52525b]">{video.durata ? `${Math.round(video.durata)} secondi` : ""} · pronto da pubblicare</p>
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        <button onClick={() => downloadVideo(video)} className="btn-blu h-12 text-sm" data-testid="download-video-button"><Download className="h-4 w-4" /> Scarica Video</button>
        <button onClick={share} disabled={sharing} className="btn-dark h-12 text-sm" data-testid="share-tiktok-button"><Share2 className="h-4 w-4" /> Condividi su TikTok</button>
      </div>
      {trial && (
        <div className="mt-5 rounded-2xl bg-[#0066FF]/10 p-4 text-sm text-[#111111]" data-testid="trial-banner">
          Questo era il tuo video di prova gratuito.{" "}
          <button onClick={onUnlock} className="font-semibold text-[#0066FF] underline-offset-4 hover:underline" data-testid="trial-unlock-button">Sblocca video illimitati</button>
        </div>
      )}
      <div className="mt-5 flex flex-wrap items-center justify-between gap-3">
        <button onClick={onNew} className="inline-flex items-center gap-2 text-sm font-semibold text-[#111111] hover:text-[#0066FF]" data-testid="new-video-button"><RotateCcw className="h-4 w-4" /> Crea un altro video</button>
        <Link to="/dashboard" className="text-sm font-semibold text-[#52525b] hover:text-[#111111]" data-testid="go-dashboard-link">I miei video →</Link>
      </div>
      {video.script?.scene && (
        <div className="mt-5 rounded-2xl border border-[#e7e7ea] bg-white">
          <button onClick={() => setShowScript((s) => !s)} className="flex w-full items-center justify-between px-5 py-4 text-sm font-semibold" data-testid="toggle-script-button">
            Leggi lo script <ChevronDown className={`h-4 w-4 transition-transform ${showScript ? "rotate-180" : ""}`} />
          </button>
          {showScript && (
            <ol className="space-y-3 px-5 pb-5 text-sm leading-relaxed text-[#3f3f46]" data-testid="video-script">
              {video.script.scene.map((s, i) => (
                <li key={i}><span className="mr-2 text-xs font-semibold uppercase tracking-wider text-[#0066FF]">{s.tipo}</span>{s.testo}</li>
              ))}
            </ol>
          )}
        </div>
      )}
    </div>
  );
};
